import { render } from "./SystemObjectsList.vue?vue&type=template&id=1846048c&scoped=true"
import script from "./SystemObjectsList.vue?vue&type=script&lang=ts"
export * from "./SystemObjectsList.vue?vue&type=script&lang=ts"

import "./SystemObjectsList.vue?vue&type=style&index=0&id=1846048c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1846048c"

export default script